import styled, { createGlobalStyle } from 'styled-components';
import { ThemeColours, transparentThemeColour } from '../../styles/ThemeColours';
import {
  BorderRadius,
  Breakpoint,
  FONT_STACK,
  STANDARD_GROW,
  STANDARD_TRANSITION,
  ZIndex,
} from '../../styles/constants';
import { onMobile } from '../../styles/onMobile';
import { prop } from '../../util/prop';
import { propSwitch } from '../../util/propSwitch';
import { ButtonVariants } from '../Button/DeprecatedButtonVariants';
import { IconButton } from '../Button/IconButton';
import { FLEX_COLS } from '../layout/FlexLayout';

export const STANDARD_WIDTH = '485px';

export const STANDARD_HEIGHT = '710px';

export const THICCER_WIDTH = '680px';

export enum GlobalClassNames {
  AFTER_OPEN = '__global_StandardModal_afterOpen',
  BEFORE_CLOSE = '__global_StandardModal_beforeClose',
  BODY = '__global_StandardModal_body',
  OVERLAY = '__global_StandardModal_overlay',
  CONTENT = '__global_StandardModal_content',
}

export const GlobalStyleSheet = createGlobalStyle<{
  width: string;
  height: string;
  padContainer: boolean;
  contentClassName: string;
}>`
  .${GlobalClassNames.BODY} {
    overflow: hidden;
  }

  .${GlobalClassNames.OVERLAY} {
    ${FLEX_COLS};
    ${STANDARD_TRANSITION};
    background: ${transparentThemeColour('black', 0.6)};
    bottom: 0;
    align-items: center;
    left: 0;
    opacity: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: ${ZIndex.POPUP};

    &.${GlobalClassNames.AFTER_OPEN} {
      opacity: 1;
    }

    &.${GlobalClassNames.BEFORE_CLOSE} {
      opacity: 0;
    }
  }

  .${prop('contentClassName')} {
    ${FONT_STACK};
    ${STANDARD_TRANSITION};
    background-color: ${ThemeColours.white};
    border-radius: ${BorderRadius.NONE};
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    margin: auto;
    height: 100%;
    width: 100%;
    max-height: unset;
    max-width: unset;
    padding: ${propSwitch('padContainer', '40px 24px', 0)};
    transform: scale(${STANDARD_GROW});
    box-sizing: border-box;
    display: flex;

    &:focus {
      outline: none;
    }

    &.${GlobalClassNames.AFTER_OPEN} {
      transform: scale(1);
    }

    &.${GlobalClassNames.BEFORE_CLOSE} {
      transform: scale(${STANDARD_GROW});
    }

    ${Breakpoint.MEDIUM} {
      border-radius: ${BorderRadius.SMALL};
      max-height: 85%;
      max-width: 95%;
      height: ${prop('height')};
      width: ${prop('width')};
      padding: ${propSwitch('padContainer', '40px', 0)};
    }
  }
`;

export const ModalContent = styled.div`
  ${FLEX_COLS};
  background-color: ${ThemeColours.white};
  border-radius: 4px;
  height: 100%;
  margin: auto;
  overflow: auto;
  padding: 0 10px;
  width: 100%;

  ${onMobile} {
    height: 100%;
  }
`;

export const StyledCloseIcon = styled(IconButton).attrs({ variant: ButtonVariants.transparent })`
  display: block;
  position: fixed;
  right: 16px;
  top: 16px;
  padding: 0;
`;
